import lightGallery from 'lightgallery'
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'

/**
 * Single product gallery: thumbnails swap the main image, and clicking the
 * main image (or its zoom button) opens every image in lightGallery.
 */
export function initProductGallery(selector)
{
	const galleryEl = document.querySelector(selector)
	if (!galleryEl) return

	const mainEl = galleryEl.querySelector('.product-gallery-main')
	const mainImage = mainEl ? mainEl.querySelector('img') : null
	const thumbs = Array.from(galleryEl.querySelectorAll('.product-gallery-thumb'))
	if (!mainImage || !thumbs.length) return

	let activeIndex = 0

	const lg = lightGallery(galleryEl, {
		dynamic: true,
		dynamicEl: thumbs.map((thumb) => ({
			src: thumb.dataset.full,
			thumb: thumb.querySelector('img').getAttribute('src'),
			alt: thumb.dataset.alt,
		})),
		plugins: [lgThumbnail, lgZoom],
		licenseKey: 'B42122F4-AE41-435C-BA3A-91BFC685EE99',
		speed: 500,
		download: false,
	})

	const showImage = (index) => {
		const thumb = thumbs[index]
		if (!thumb) return

		mainImage.src = thumb.dataset.src
		mainImage.srcset = thumb.dataset.srcset || ''
		mainImage.alt = thumb.dataset.alt || ''

		thumbs.forEach((el, i) => {
			el.classList.toggle('is-active', i === index)
			el.setAttribute('aria-pressed', i === index ? 'true' : 'false')
		})

		activeIndex = index
	}

	thumbs.forEach((thumb, index) => {
		thumb.addEventListener('click', () => showImage(index))
	})

	// The zoom button sits inside the main image, so one listener covers both
	mainEl.addEventListener('click', () => lg.openGallery(activeIndex))

	// Leave the main image on whichever slide the visitor closed the lightbox on
	galleryEl.addEventListener('lgBeforeClose', () => showImage(lg.index))
}
